import KeyboardNavigation from '../../grid/keyboardNavigation';

export default instance => {
  instance.attachEvent('onDestroy', () => {
    KeyboardNavigation.onGanttDestroy();
  });
};
